import { FaCheckCircle } from "react-icons/fa";
import { useSelector } from "react-redux";

export default function VerificationSubmitted() {

    const user = useSelector((state) => state.auth.user);

    return (
        <div className="items-center text-center bg-black overflow-y-auto">

            {/* Header */}
            <h1 className="text-red-500 text-lg font-semibold text-center mt-24">
                Become a Host on Red Video Chat!
            </h1>

            {/* Center Content */}
            <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center">
                {/* Success Icon */}
                <FaCheckCircle className="text-green-500 text-6xl mb-4" />

                {/* Title */}
                <h2 className="text-green-500 text-lg font-semibold mb-2">
                    Your Request Has Been Submitted!
                </h2>

                {/* Description */}
                <p className="text-gray-300 text-sm max-w-md mb-8">
                    Your ID is being verified. Usually within 1 hour, and at most
                    within 24 hours depending on workload, the verification process
                    will be completed.
                </p>

                {/* Status */}
                <div className="mb-6">
                    <p className="text-white text-sm mb-2">
                        ID Approval Status
                    </p>
                    <span className="inline-flex items-center gap-2 px-4 py-1 rounded-full
                                     bg-green-900 text-green-400 text-xs">
                        ⏳ In Review
                    </span>
                </div>

                {/* Unique ID */}
                <p className="text-yellow-400 text-xs mb-10">
                    Unique Id: {user.unique_id}
                </p>
            </div>
        </div>
    );
}